import { Box, TextField } from "@mui/material";
import { useField } from "formik";
import WordCountMessage from "./narrative/WordCountMessage";
import { countWords } from "../utils";
import { shortDescriptionMaxWords } from "../../formatting/defaults";

function ShortDescriptionField() {
  const [field, meta] = useField<string>("solution-short-description");
  const hasError = meta.touched && Boolean(meta.error);

  return (
    <Box sx={{ paddingBottom: 2 }}>
      <TextField
        slotProps={{ htmlInput: { "aria-label": "Short Description" } }}
        id="solution-short-description"
        label="Short Description"
        variant="standard"
        rows={4}
        multiline
        fullWidth
        autoComplete="disabled"
        name={field.name}
        onChange={field.onChange}
        onBlur={field.onBlur}
        value={field.value}
        error={hasError}
        helperText={hasError ? meta.error : undefined}
      />
      <WordCountMessage
        count={countWords(field.value ?? "")}
        maxWords={shortDescriptionMaxWords}
        error={hasError}
      />
    </Box>
  );
}

export default ShortDescriptionField;
